import { Link } from 'react-router-dom';
import { useAuth } from '../../Common/Configurations/AuthContext';
const UmrahTabs = (props) => {
    const { user } = useAuth();
    return (
            <ul className="nav nav-tabs nav-tabs-custom nav-success nav-justified mb-3" role="tablist">
                <li className="nav-item" role="presentation">
                    <Link to={"/umrah"} className={props.pageName === "UMRAHPACKAGE" ? "nav-link active bg-primary text-white" : "nav-link"}>CREATE UMRAH</Link>
                </li>
                <li className="nav-item" role="presentation">
                    <Link to={"/umrahlist"} className={props.pageName === "UMRAHPACKAGES" ? "nav-link active bg-primary text-white" : "nav-link"}>UMRAH PACKAGES</Link>
                </li>  
                  {user && user.isWebsite && (
        <li className="nav-item" role="presentation">
            <Link 
                to={"/websiteumrahpackages"} 
                className={props.pageName === "WEBSITEUMRAHPACKAGES" ? "nav-link active bg-primary text-white" : "nav-link"}
            >
                WEBSITE UMRAH PACKAGES
            </Link>
        </li>
      )}              
                <li className="nav-item" role="presentation">
                    <Link to={"/umrahenquiry"} className={props.pageName === "UMRAH ENQUIRIES" ? "nav-link active bg-primary text-white" : "nav-link"}>UMRAH ENQUIRIES</Link>
                </li>
                {/* <li className="nav-item" role="presentation">
                    <Link to={"/packagedates"} className={props.pageName === "PACKAGEDATES" ? "nav-link active bg-primary text-white" : "nav-link"}>PACKAGE DATES</Link>
                </li> */}
            </ul>
    );
};

export default UmrahTabs;
